import { BuyerContainer } from '@/components/Buyer/BuyerDirectory/Table/Buyer';
import { HeaderSection } from '@/components/Common/HeaderSection/HeaderSection';
import TopLevelSectionLayout from '@/layouts/TopLevelSectionLayout/TopLevelSectionLayout';

export default function BuyerDirectory() {
  return (
    <TopLevelSectionLayout>
      <HeaderSection
        title={'Directorio de Compradores'}
        sx={{ px: { xs: '16px', md: '0px' }, pb: { xs: '0px', md: '16px' } }}
      />
      <BuyerContainer />
    </TopLevelSectionLayout>
  );
}
